'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _validationConstants = require('../../validationConstants');

var _idValidator = require('../../../uid/idValidator');

var ELEMENT_ID_ERROR_OBJECT = {
    name: _validationConstants.FAILURE_NAMES.elementId,
    type: _validationConstants.FAILURE_TYPES.ERROR,
    message: 'Not a valid elementId'
};

exports.default = function (fieldValue, validationConfig) {
    if (!fieldValue) return;

    if (!(0, _idValidator.isElementId)(fieldValue)) return ELEMENT_ID_ERROR_OBJECT;

    return null;
};


//////////////////
// WEBPACK FOOTER
// ./src/common/validation/validators/type/elementIdValidator.js
// module id = 2303
// module chunks = 0